import React, { useContext, useMemo, useState } from 'react';
import { SliderContext } from "../providers/SliderProvider.js";
import styles from "./SliderNotchLabel.module.js";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export function SliderNotchLabels({
  notches
}) {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: notches?.map(({
      value,
      label
    }, index) =>
    /*#__PURE__*/
    /* eslint-disable react/no-array-index-key */
    _jsx("div", {
      className: styles.container,
      children: /*#__PURE__*/_jsx(SliderNotchLabel, {
        value: value,
        label: label
      })
    }, index)
    /* eslint-enable react/no-array-index-key */)
  });
}
function SliderNotchLabel({
  label,
  value
}) {
  const [labelEle, setLabelEle] = useState(null);
  const {
    calcCSSPosition,
    calcLabelOffset
  } = useContext(SliderContext);
  return /*#__PURE__*/_jsx("div", {
    ref: setLabelEle,
    className: styles.label,
    style: {
      left: calcCSSPosition(value, calcLabelOffset(value, labelEle))
    },
    children: useMemo(() => label(value), [label, value])
  });
}